import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import AddGovtOrderDetailsModal from "./AddGovtOrderDetailsModal";
import UpdateGovtOrderDetailsModal from "./UpdateGovtOrderDetailsModal";

const GovtOrderDetails = () => {
  const handle = useFullScreenHandle();
  const [selectedRows, setSelectedRows] = useState([]);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rmvBtn, setRmvBtn] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedRowsData, setselectedRowsData] = useState({});
  const [rowAddData, setRowAddData] = useState({
    location: "",
    alloted: "",
    rca_no: "",
    size: "",
  });

  const formRef = useRef(null);
  // console.log("rowData", rowAddData)

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const updateHandleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setselectedRowsData(() => {
        return {
          ...selectedRowsData,
          [name]: value,
        };
      });
    } else {
      console.error("Event or event.target is undefined");
    }
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { location, alloted, rca_no, size } = rowAddData;

    let BASE_URL = SERVER_URL + `/api/order/orderDetails/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        location,
        alloted,
        rca_no,
        size,
      }),
    });
    const response = await res.json();
    console.log("response", response);

    if (res.ok) {
      console.log(response);
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getData = async () => {
    let BASE_URL = SERVER_URL + `/api/order/all-govtOrderDetails/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setRowData(result.data);

      // Check if gridRef is defined and has the api property before using it
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.hideOverlay();
      }
    } else {
      setRowData([]);
    }
  };

  let check = true;
  const [loadingOverlayVisible, setLoadingOverlayVisible] = useState(false);
  useEffect(() => {
    if (check) {
      if (loadingOverlayVisible) {
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.showLoadingOverlay();
        }
      }

      getData();
      setLoadingOverlayVisible(true);
    }
    check = false;
  }, []);

  // const addData = (newData) => {
  //   console.log("Adding data:", newData);
  //   setRowData((prevData) => [...prevData, newData]);
  // };

  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    updateData(updatedData);
    // setRowData((prevData) =>
    //   prevData.map((row) => (row === params.data ? updatedData : row))
    // );
    // console.log("Updated data:", updatedData);
  };

  const onSelectionChanged = useCallback((event) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes?.length > 1) {
      setRmvBtn(true);
    }
    if (selectedNodes?.length < 2) {
      setRmvBtn(false);
    }
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
    // window.alert("selection changed, " + rowCount + " rows selected");
  }, []);

  const deleteSelectedRows = () => {
    setRowData((prevData) =>
      prevData.filter((row) => !selectedRows.includes(row))
    );
    // console.log(selectedRows);
    // Clear the selection after deletion
    setSelectedRows([]);
  };

  const deleteRow = async (id) => {
    // setRowData((prevData) => prevData.filter((row) => row !== rowData));

    let BASE_URL = SERVER_URL + `/api/order/govtOrderDetails/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      console.log(response);
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const addDataToModal = async (rowData) => {
    setselectedRowsData(rowData);
  };
  const updateData = async (rowData) => {
    const {
      id,
      location,
      company_id,
      order_id,
      size,
      alloted,
      rca_qty,
      order_qty,
    } = rowData;
    let BASE_URL = SERVER_URL + `/api/order/govtOrderDetails/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_id,
        order_id,
        location,
        rca_qty,
        alloted,
        order_qty,
        size,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      console.log(response);
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };
  const [colDefs, setColDefs] = useState([
    {
      headerName: "S. No",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 150,
      headerCheckboxSelection: true,
      checkboxSelection: true,
    },
    {
      headerName: "Name of Circle",
      field: "order.location",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Factory",
      field: "company.company_name",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Alloted",
      field: "alloted",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Rca no",
      field: "order.rca_no",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Order placed",
      field: "location",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Size",
      field: "order.size",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Order details",
      field: "order_details",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Rca quantity",
      field: "rca_qty",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Order quantity",
      field: "order_qty",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Rca balance",
      field: "rca_balance_qty",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => deleteRow(params.data.id)}
          >
            <i className="mdi mdi-delete" />
          </button>{" "}
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => addDataToModal(params.data)}
            data-toggle="modal"
            data-target="#updateModal"
          >
            <i className="mdi mdi-note-edit-outline" />
          </button>
        </>
      ),
      minWidth: 205,
    },
  ]);

  const sortingOrder = useMemo(() => {
    return ["desc", "asc", null];
  }, []);
  const defaultColDef = useMemo(() => ({
    filter: true,
    flex: 1,
    editable: true,
    headerPosition: "sticky",
  }));
  const gridOptions = useMemo(
    () => ({
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      suppressCellSelection: true,
    }),
    []
  );
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    getData();
  };

  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            Govt Order Details &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          <FullScreen handle={handle}>
            <div className="table_btn">
              <div className="mb-3">
                <button
                  style={{ display: handle.active ? "none" : "" }}
                  data-toggle="modal"
                  data-target="#exampleModal"
                  className="btn btn-outline-primary"
                >
                  <span className="mr-1">
                    <i className="mdi mdi-briefcase-upload" />
                  </span>
                  Add Govt Order
                </button>
                {rmvBtn && (
                  <button
                    style={{ display: handle.active ? "none" : "" }}
                    onClick={deleteSelectedRows}
                    className="btn btn-outline-danger ml-1"
                  >
                    <span className="mr-1">
                      <i className="mdi mdi-delete" />
                    </span>
                    Delete Selected Rows
                  </button>
                )}
              </div>

              <div
                style={{
                  display: handle.active ? "none" : "block",
                  marginBottom: "20px",
                }}
              >
                <button
                  style={{ display: handle.active ? "none" : "" }}
                  onClick={() => onBtnExport()}
                  className="btn btn-outline-excel mr-1 "
                >
                  <span className="mr-1">
                    <i className="mdi mdi-file-export"></i>
                  </span>
                  Export to Excel
                </button>
                <button
                  style={{ cursor: "pointer" }}
                  className="btn btn-light btn-icon-text"
                  onClick={handle.enter}
                >
                  Full Screen{" "}
                  <span>
                    <i className="mdi mdi-crop-free" />
                  </span>
                </button>
              </div>
            </div>
            <div
              className={`${
                handle.active ? "fullscreen-container full-screen-mode" : ""
              }`}
            >
              <div
                className="ag-theme-quartz"
                style={{ width: "100%", height: 550 }}
              >
                <AgGridReact
                  ref={gridRef}
                  rowData={rowData}
                  columnDefs={colDefs}
                  defaultColDef={defaultColDef}
                  // domLayout="autoHeight"
                  headerHeight={40}
                  rowHeight={50}
                  sortingOrder={sortingOrder}
                  enableCellTextSelection={true}
                  // gridOptions={gridOptions}
                  rowSelection={"multiple"} // For row selection
                  suppressRowClickSelection={true} // For row selection
                  suppressCellSelection={true} // For row selection
                  onGridReady={onGridReady}
                  overlayLoadingTemplate={
                    '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
                  }
                  onCellValueChanged={onCellValueChanged}
                  onSelectionChanged={onSelectionChanged}
                />
              </div>
            </div>
          </FullScreen>
          <AddGovtOrderDetailsModal
            handleChange={handleChange}
            //   setimgfile={setimgfile}
            handleAddDataSubmit={handleAddDataSubmit}
            formRef={formRef}
            getData={getData}
          />
          <UpdateGovtOrderDetailsModal
            selectedRowsData={selectedRowsData}
            updateHandleChange={updateHandleChange}
            getData={getData}
          />
        </div>
      </div>
    </>
  );
};

export default GovtOrderDetails;
